const RegistrationClient = {
  registration: "candidates/registration",
  emailValidation: "registration/email",

  verificationOtp: "registration/verification",
};

export default RegistrationClient;
